import React, { useState, useEffect } from "react";
import CreateTool from "./CreateTool";
import ViewTools from "./ViewTools";
import toast from "react-hot-toast";

const TopNavbar = () => {
  const [activeContent, setActiveContent] = useState("Add Tool");
  const [data, setData] = useState([]);
  const menuItems = [
    {
      name: "Add Tool",
      key: "Add Tool",
      component: <CreateTool />,
    },
    {
      name: "View Tools",
      key: "View Tools",
      component: <ViewTools records={data} />,
    },
  ];

  const fetchtool = async () => {
    const url = "https://rohan-tax-services.onrender.com/api/auth/fetchtool";

    const response = await fetch(url, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
    });
    const result = await response.json();
    if (response.ok) {
      setData(result);
    } else {
      toast.error(result.msg || "Failed to fetch tools");
    }
  };

  useEffect(() => {
    fetchtool();
  }, []);

  return (
    <>
      <div>
        <nav className="bg-white text-black p-3 shadow-md">
          <div className="flex justify-between items-center">
            <ul className="flex space-x-3">
              {menuItems.map((item) => (
                <li key={item.key}>
                  <button
                    onClick={() => setActiveContent(item.key)}
                    className={`px-4 py-2 border-b-2 ${
                      activeContent === item.key
                        ? "border-blue-500 text-blue-500"
                        : "border-transparent"
                    }`}
                  >
                    {item.name}
                  </button>
                </li>
              ))}
            </ul>
          </div>
        </nav>
        <div className="p-5 flex-grow py-10 w-full" style={{ height: "100vh" }}>
          {menuItems.map(
            (item) =>
              activeContent === item.key && (
                <div key={item.key} className="w-full">
                  {item.component}
                </div>
              )
          )}
        </div>
      </div>
    </>
  );
};

export default TopNavbar;
